import React from 'react';

/**
 * A floating action bar component for permit forms
 * 
 * @param {Object} props - Component props
 * @param {Function} props.onCancel - Function to call when Cancel button is clicked
 * @param {Function} props.onDownload - Function to call when Download button is clicked
 * @param {Function} props.onSubmit - Function to call when Save/Update button is clicked
 * @param {boolean} props.loading - Whether the form is in a loading state
 * @param {boolean} props.isUpdate - Whether the form is in update mode (vs. create mode)
 * @returns {JSX.Element} - The rendered component
 */
const FloatingActionBar = ({ onCancel, onDownload, onSubmit, loading, isUpdate }) => {
  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white shadow-lg border-t border-gray-200 p-4 z-50">
      <div className="max-w-7xl mx-auto flex justify-end space-x-3">
        <button
          type="button"
          onClick={onCancel}
          className="px-4 py-2 bg-gray-300 text-gray-800 rounded hover:bg-gray-400"
        >
          Cancel
        </button>
        <button
          type="button"
          onClick={onDownload}
          className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700"
        >
          Download
        </button>
        <button
          type="button"
          onClick={onSubmit}
          disabled={loading}
          className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 disabled:opacity-50"
        >
          {loading ? 'Saving...' : isUpdate ? 'Update' : 'Save'}
        </button>
      </div>
    </div>
  );
};

export default FloatingActionBar;
